import { AfterViewInit, Component } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet.fullscreen/Control.FullScreen';
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';
import { ApiService } from '../../services/api.service';
import { timer } from 'rxjs';
import { KmlService } from '../../services/kml.service';
import { MarkersService } from '../../services/markers.service';

//const timer:any = interval(10000);
const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements AfterViewInit {
  public map: any;
  public current_position: any = null;
  private selected: Route[] = [];
  private bluedot =  '../../../assets/images/map/blue-dot.png';

  private transitRefresh = timer(1000, 5000).subscribe(t => {
    for (const route of this.selected){
      this.kmlService.get(this.map, route);
      this.markersService.fetch(this.map, route);
    }
  });

  constructor(private routeService: RouteService, private kmlService: KmlService, private markersService: MarkersService, private apiService: ApiService) {}

  ngAfterViewInit(): void {
    this.initMap();
    this.selected = this.routeService.selected;
    this.routeService.cast.subscribe(user=> this.checkSelected());
  }

  ngOnDestroy(){
    this.transitRefresh.unsubscribe();
  }

  private initMap(): void {
    this.map = L.map('map', {
      fullscreenControl: true,
   
      center: [39.952333, -75.163916],
      zoom: 10
    });

    //const tiles = L.tileLayer('https://www3.septa.org/api/tiles/{z}-{x}-{y}',
    const tiles = L.tileLayer('https://tiles.septa.org/tiles/raster/{z}/{x}/{y}.png',
      {
        maxZoom: 17,
        minZoom: 9,
        attribution:
        '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/about/">OpenStreetMap contributors</a>'
      }
    );

    tiles.addTo(this.map);
    this.map.locate({setView: true, maxZoom: 11});
    this.move_location(this.map, this.current_position);
  }

  private checkSelected(){
    this.markersService.clearMarkers(this.map);
    this.kmlService.clear(this.map);
    this.transitRefresh.unsubscribe();

    for (const route of this.selected){
      this.kmlService.get(this.map, route);
    }

    this.transitRefresh = timer(2000, 5000).subscribe(t => {
      for (const route of this.selected){
        this.markersService.fetch(this.map, route);
      }
    });
  }

  private move_location(map, current_position){
    var icon = L.icon( {
      iconUrl: this.bluedot,
      iconAnchor:   [30,25],
    } );

    if(typeof(map) != "undefined"){
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
              var coordinates = new L.LatLng(position.coords.latitude, position.coords.longitude);
              if(current_position == null){
                current_position = L.marker(coordinates, {icon: icon}).addTo(map);
              }
              else{
                current_position.setLatLng(coordinates);
              }
          },function(){
              //handleLocationError(true, infoWindow, map.getCenter());
            });
      }
    }
  }
}
